export default __webpack_public_path__ + "static/media/logo.04796f0f.svg";